import * as React from 'react';
import Spinner from '../../common/components/spinner/spinner';
import Translate from '../../common/functions/translate';
import AlertMessage from '../../common/components/alertMessage/alertMessage';
import ConfirmDialog from '../../common/components/confirmDialog/confirmDialog';
import DisposalPlacesList from './disposalPlacesList';
import { DisposalPlacesModel } from '../../models/disposalPlaces/disposalPlaces';
import { DisposalPlacesSettings } from '../../models/disposalPlaces/disposalPlacesSettings';
import { DisposalPlacesWrapperModel } from '../../models/disposalPlaces/disposalPlacesWrapper';
import DisposalService from '../../services/disposalPlacesService';
import DisposalPlaceAddEditDialog from './disposalPlacesAddEdit';
import { DisposalPlacesContentModel } from '../../models/disposalPlaces/disposalPlacesContent';
import * as HelperFunctions from '../../common/functions/helperFunctions';
import { Lang } from '../../common/enums';

interface IProps {
}

interface IState {
    error: any,
    isLoading: boolean,
    isVisibleDialogWrap: boolean,
    isVisibleDialog: boolean,
    numberOfRows: number,
    totalRecordsCount: number,
    first: number,
    isVisibleConfirmDialog: boolean,
    currentPlace: DisposalPlacesModel,
    disposalPlaces: Array<DisposalPlacesModel>,
    disposalSetting: DisposalPlacesSettings,
    validationMessage: string
}

const initFrom = 0;
const numberOfRows = 10;

class PharmaciesContainer extends React.Component<IProps, IState> {
    disposalService = new DisposalService();
    messages: any;

    constructor(props: IProps) {
        super(props);

        this.state = {
            error: null,
            isLoading: false,
            isVisibleDialogWrap: false,
            isVisibleDialog: false,
            numberOfRows: numberOfRows,
            first: initFrom,
            totalRecordsCount: 0,
            isVisibleConfirmDialog: false,
            currentPlace: new DisposalPlacesModel(),
            disposalPlaces: new Array<DisposalPlacesModel>(0),
            disposalSetting: new DisposalPlacesSettings(),
            validationMessage: ''
        }
    }

    componentDidMount() {
        this.getAllDisposalPlaces(this.state.first, this.state.numberOfRows);
    }

    handleOnPageClick = (e) => {
        const startIndex = e.first;
        this.getAllDisposalPlaces(startIndex, this.state.numberOfRows);
    }

    getAllDisposalPlaces(from: number, numberOfRows: number) {
        this.setState({
            isLoading: true
        });

        this.disposalService.getAllPlaces(from, numberOfRows, this.state.disposalSetting).then(
            (data: DisposalPlacesWrapperModel) => {
                this.setState({
                    isLoading: false,
                    first: from,
                    disposalPlaces: data.disposalPlaces,
                    totalRecordsCount: data.totalRecords
                });
            })
            .catch(error => {
                this.setState({
                    isLoading: false,
                    error
                });
            });
    }

    handleAddAndEditClick = id => {
        if (!id) { // Add			
            let disposal = new DisposalPlacesModel();
            let contentList = new Array<DisposalPlacesContentModel>(0);
            const langKeys = HelperFunctions.getEnumKeys(Lang);

            langKeys.map(k => {
                let content = new DisposalPlacesContentModel();
                content.langId = parseInt(Lang[k]);
                content.city = '';
                content.region = '';
                content.address = '';
                content.description = '';
                contentList.push(content);
            });

            disposal.disposalPlacesContent = contentList;
            this.setCurrentPlace(disposal);
            this.showEditDialog(true);
        } else { // Edit
            this.setState({
                isLoading: true
            });
            this.disposalService.getDisposalPlace(id)
                .then(
                    (data: DisposalPlacesModel) => {
                        this.setCurrentPlace(data);
                        this.showEditDialog(true);
                        this.setState({
                            isLoading: false
                        });
                    },
                    error => {
                        this.setState({
                            error,
                            isLoading: false
                        });
                    }
                );
        }
    };

    showEditDialog = (show: boolean) => {
        this.setState({
            isVisibleDialogWrap: show,
            validationMessage: ''
        });
        setTimeout(() => this.setState({
            isVisibleDialog: show
        }));
    };

    setCurrentPlace(disposalPlace: DisposalPlacesModel) {
        this.setState({ currentPlace: { ...disposalPlace } });
    }

    getDisposalPlace = (id) => {
        this.disposalService.getDisposalPlace(id)
            .then(
                (data: DisposalPlacesModel) => {
                    this.setCurrentPlace(data);
                    this.setState({
                        isLoading: false
                    });
                },
                error => {
                    this.setState({
                        error,
                        isLoading: false
                    });
                });
    }

    handleDeleteClick = (id) => {
        this.getDisposalPlace(id);
        this.setState({
            isVisibleConfirmDialog: true
        });
    };

    deleteDisposalPlace(id) {
        this.setState({
            isVisibleConfirmDialog: false,
            isLoading: true
        });

        this.disposalService.deleteDisposalPlace(id)
            .then(
                data => {
                    this.getAllDisposalPlaces(this.state.first, this.state.numberOfRows);
                    this.setState({
                        isLoading: false
                    });
                },
                error => {
                    this.setState({
                        error,
                        isLoading: false
                    });
                });
    }

    handleCancelButton = () => {
        this.showEditDialog(false);
    };

    handleSaveButton = (currentDisposal: DisposalPlacesModel, close: boolean) => {
        this.setState({
            isLoading: true
        });

        if (!currentDisposal.disposalPlaceId) { // Add
            this.disposalService.addDisposalPlace(currentDisposal)
                .then(
                    (data) => {
                        if (close) {
                            this.showEditDialog(false);

                        }
                        this.setCurrentPlace(new DisposalPlacesModel());
                        this.getAllDisposalPlaces(this.state.first, this.state.numberOfRows);
                        this.setState({
                            isLoading: false
                        });
                    },
                    error => {
                        this.showEditDialog(false);
                        this.setCurrentPlace(new DisposalPlacesModel());
                        this.setState({
                            error
                        });
                        this.setState({
                            isLoading: false
                        });
                    }
                );
        } else { // Edit
            this.disposalService.editDisposalPlace(currentDisposal.disposalPlaceId, currentDisposal)
                .then(
                    (data) => {
                        if (close) {
                            this.showEditDialog(false);
                        }
                        this.setCurrentPlace(new DisposalPlacesModel());
                        this.getAllDisposalPlaces(this.state.first, this.state.numberOfRows);
                        this.setState({
                            isLoading: false
                        });
                    },
                    error => {
                        this.showEditDialog(false);
                        this.setCurrentPlace(new DisposalPlacesModel());
                        this.setState({
                            error
                        });
                        this.setState({
                            isLoading: false
                        });
                    });
        }
    };


    public render() {

        const { isLoading, error, totalRecordsCount, first, numberOfRows, disposalPlaces } = this.state;

        return (
            <div>

                <h3>Disposal places</h3>

                {isLoading ? <Spinner /> : null}

                {error ? <AlertMessage type='danger'>Error: {error.message}</AlertMessage> : null}

                {this.state.isVisibleDialogWrap ? (
                    <DisposalPlaceAddEditDialog
                        saveClick={this.handleSaveButton}
                        cancelClick={this.handleCancelButton}
                        currentDisposalPlace={this.state.currentPlace}
                        isVisible={this.state.isVisibleDialog}
                    />
                ) : null}

                <div className="mb-2">
                    <button
                        onClick={() => this.handleAddAndEditClick(null)}
                        className="btn btn-success"
                        style={{ marginRight: "5px" }}>
                        Add New
         			 </button>
                </div>

                <DisposalPlacesList
                    disposalPlaces={disposalPlaces}
                    rows={numberOfRows}
                    totalRecords={totalRecordsCount}
                    onPageClick={this.handleOnPageClick}
                    first={first}
                    loading={Spinner}
                    editClick={this.handleAddAndEditClick}
                    deleteClick={this.handleDeleteClick}
                />

                <ConfirmDialog
                    headerTitle="Confirm Dialog"
                    isVisible={this.state.isVisibleConfirmDialog}
                    yesClick={() => { this.deleteDisposalPlace(this.state.currentPlace.disposalPlaceId) }}
                    noClick={() => { this.setState({ isVisibleConfirmDialog: false }) }}>
                    Are you sure that you want to delete "{this.state.currentPlace.address}"?
        </ConfirmDialog>
            </div>
        )
    }
}

export default PharmaciesContainer;